import { getGroupMemberBalances, getMemberBalanceByMemberId } from "../../reducers/transactions/actions"
import { backendAPI } from "../../api"
import { db, deleteCacheByKey, updateDependencyRecords } from "../../../view/shared/utilities/cache"
import { safeApiCall } from "../../api/offline"
import { fetchTransactionsAggreg } from "../getMemberAggregates"
import { memberLoaded } from "./getMember"
import { triggerAction } from "../../constants"
import { processOfflineQueue } from "../../api/queue"
export const LOADED_VSLA_MEMBERS = "LOADED_VSLA_MEMBERS"
export const LOAD_LOCAL_VSLA_MEMBERS = "LOAD_LOCAL_VSLA_MEMBERS"

export const vslaMembersLoadStarted = (bool) => ({
  type: "VSLA_MEM_LOAD_START",
  isloading: bool,
})

export const vslaMemberLoadError = (error) => ({
  type: "VSLA_MEM_LOAD_ERROR",
  error: error,
})

function mergeMembers(data, localMembers) {
  const mergedMap = new Map();

  // 1. Add all items from 'data' to the map, prioritizing them
  data.forEach(member => {
    mergedMap.set(member.pubkey, member);
  });

  // 2. Process localMembers
  localMembers.forEach(localMember => {
    const memberData = {
      ...localMember.payload.data,
      cacheId: localMember.cacheId,
      error: localMember.error || null,
      syncStatus: localMember.status || 'pending'
    };

    // If the phone_number doesn't exist in the map (meaning it's not in 'data'),
    // then add it. If it exists, it means a 'data' member with the same phone_number
    // already took precedence, so we do nothing.
    if (!mergedMap.has(memberData.pubkey)) {
      mergedMap.set(memberData.pubkey, memberData);
    }
  });

  // 3. Convert the map values back to an array
  return Array.from(mergedMap.values());
}


export function fetchVslasMembers() {
  return async (dispatch, getState) => {
    try {
      const { group, user } = getState()
      if (!group?.id) {
        console.error("Group not found or group ID is missing.")
        return
      }
      const metaObject = { userId: user?.id }
      let resolvedDependency = false
      const { data } = await safeApiCall(
        {
          cacheEnabled: true,
          url: `/groups-hedera/${group?.id}/members`,
        },
        async () =>
          backendAPI.get(`/groups-hedera/${group?.id}/members`),
      )

      // Dispatch the action to get group member balances before
      await dispatch(getGroupMemberBalances())
      let localMembers = await db.offlineRequests.toArray()
      localMembers = localMembers.filter(({ userId, entityType }) => userId === user?.id && entityType === 'members')
      // Dispatch the updated loadedvslaMembers array
      dispatch(triggerAction(LOADED_VSLA_MEMBERS, mergeMembers(data, localMembers)))
      for (const member of data) {
        // cache the get requests
        dispatch(getMemberBalanceByMemberId(member?.id))
        dispatch(fetchTransactionsAggreg(member?.id))

        if (member?.id) {
          // remove the member request from cache
          await deleteCacheByKey("offlineRequests", "cacheId", member.pubkey)

          // see it is a dependecny to other requests
          const requests = await db.offlineRequests.toArray();
          const requiresMemberId = requests.filter(({ needBodyUpdate, userId }) => {
            return userId === metaObject.userId && needBodyUpdate?.member_id === member.pubkey
          })
          if (requiresMemberId.length > 0) {
            await updateDependencyRecords(
              [member?.pubkey, metaObject.userId],
              {
                ...metaObject,
                key: "member_id",
                value: member?.id,
                entityType: member?.pubkey,
              },
              metaObject.userId
            )
            resolvedDependency = true
          }
          else {
            // clean up, if not required
            await db.table('depsMap')
              .where({
                entityType: member.pubkey,
                userId: metaObject.userId
              })
              .delete();
          }
        }
      }

      if (resolvedDependency) {
        // A dependency been resolved. start processing
        processOfflineQueue()
      }
      return Promise.resolve(data)
    } catch (error) {
      dispatch(vslaMemberLoadError(error))
      return Promise.reject()
    }
  }
}
